module.exports = __webpack_public_path__ + "static/media/MFA-Background-002.35afafda.png";